/*
 * @Author: 18210594266 washqirui@163.com
 * @Date: 2022-11-21 21:15:09
 * @LastEditors: 18210594266 washqirui@163.com
 * @LastEditTime: 2022-11-24 08:46:09
 * @FilePath: \jutoujutou\jutou\current\frontend\jutou\src\api\competeManage.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import {post,get} from '../libs/ajax.js'

export default {
    // 获取筛选条件
    getXXX: (data, options) => {
        return get('/url', data, options)
    },
    postXXX: (data, options) => {
        return post('/url', data, options)
    },
    //竟代-管理列表
    getCompeteList: (data, options) => {
        return get('/compete/get_list', data, options)
    },
    //竟代-管理数据列表（日历）
    getCompeteDataList: (data, options) => {
        return get('/compete/data/get_list', data, options)
    },
    //数据编辑-保存
    createCompeteData: (data, options) => {
        return post('/compete/data/create', data, options)
    },


    //竟代管理-添加
    addCompete: (data, options) => {
        return post('/compete/add', data, options)
    },
    //竟代管理-编辑
    editCompete: (data, options) => {
        return post('/compete/edit', data, options)
    },
    //竟代管理-删除
    delCompete: (data, options) => {
        return post('/compete/del', data, options)
    },

    //竟代管理-是否覆盖数据
    dataCheck: (data, options) => {
        return post('/compete/data/check', data, options)
    },


}
